<template>
  <div class="role">
    <query-select
      :status="status"
      ref="queryselect"
    ></query-select>
    <div class="page">
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
            placeholder="姓名/手机号/钱包地址"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
        </div>
      </div>
      <div class="statistics">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="card">
              <p class="center data">{{total}}</p>
              <p class="center">客户数</p>
            </div>

          </el-col>
          <el-col :span="12">
            <div class="card">
              <p class="center data">{{statistics.totalSum}}</p>
              <p class="center">客户资产</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="page-content white-bg">
        <vs-table :data="listData">
          <template slot="thead">
            <vs-th class="id-th">
              ID
            </vs-th>
            <vs-th class="name-table-col">
               姓名
            </vs-th>
            <vs-th class="type-table-col">
              类型
            </vs-th>
            <vs-th>
              手机号
            </vs-th>
            <vs-th>
              钱包地址
            </vs-th>
            <vs-th>
              资产(USDT)
            </vs-th>
            <vs-th>
              冻结资金(USDT)
            </vs-th>
            <vs-th>
              注册时间
            </vs-th>
            <vs-th class="status-table-col">
              实名状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td class="id-th">
                <span>{{tr.id}}</span>
              </vs-td>

              <vs-td class="name-table-col">
                {{tr.custName}}
              </vs-td>

              <vs-td class="type-table-col">
                {{tr.custType == 1 ? '商户': '个人'}}
              </vs-td>
              <vs-td>
                {{tr.phone}}
              </vs-td>
              <vs-td>
                <div class="qr-td">
                  <img
                    v-if="tr.qrUrl"
                    class="qr-code-img"
                    :src="tr.qrUrl"
                    alt="">
                  <span>{{tr.address}}</span>
                </div>
              </vs-td>
              <vs-td>
                {{tr.usdtTotal}}
              </vs-td>
              <vs-td>
                {{tr.usdtFrozen}}
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>
              <vs-td class="status-table-col">
                <span
                  class="status"
                  :class="{
                    green: tr.auditStatus == 3,
                    red: tr.auditStatus == 1,
                    gray: tr.auditStatus == 0 || tr.auditStatus == 2,
                  }"
                >{{getState(tr)}}</span>
              </vs-td>
              <vs-td>
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="查看"
                    placement="top"
                  >
                    <icon-svg
                      @click.native="checkHandle(tr)"
                       icon-class="eye"
                      class="pointer check-icon"
                    ></icon-svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计{{total}}条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import querySelect from '@/components/walletManage/list/querySelect'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  import {parseTime} from "../../../utils";
  export default {
    name: "index",
    props: {
      status: {
        type: Number,
        default: 0
      },
    },
    components:{
      sizeChange,
      querySelect,
    },
    watch: {
      status(newValue, oldValue) {
        this.page = 1;
        this.init();
      }
    },
    computed: {
      ...mapGetters(['beforePage']),
    },
    data() {
      return {
        statistics: {
          totalSum: ''
        }
      }
    },
    mixins: [initData],
    mounted(){
      this.init();
    },
    methods: {
      parseTime,
      beforeInit(){
        this.url = '/pms/crm/pageCust';
        if(this.beforePage){
          this.page = this.beforePage;
          this.$store.commit('setBeforePage', 0);
        }
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        if(this.status > -1){
          this.params.auditStatus = this.status;
        }
        if(this.$refs.queryselect.type){
          this.params.custType = this.$refs.queryselect.type;
        }
        if(this.$refs.queryselect.idStatus !== '' && this.$refs.queryselect.idStatus !=  null){
          this.params.auditStatus = this.$refs.queryselect.idStatus;
        }
        if(this.$refs.queryselect.duratiem.length){
          this.params.startTime = parseTime(this.$refs.queryselect.duratiem[0]);
        }
        if(this.$refs.queryselect.duratiem.length){
          this.params.endTime = parseTime(this.$refs.queryselect.duratiem[1]);
        }
        return true;
      },
      getState(tr){
        switch (tr.auditStatus) {
          case 0:
            return '未认证';
          case 1:
            return '待审核';
          case 2:
            return '审核拒绝';
          case 3:
            return '审核通过';
        }
      },
      closeHandle(){
        this.active = false;
      },
      checkHandle(tr){
        this.$router.push({name: 'customerDetail', params:{ id: tr.id},query:{page: this.page}});
      },
    },
  }
</script>
<style lang="scss">
  .role {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .role-icon {
    margin-left: 10px;
  }
  .vs-self-tooltip {
    display: inline-block;
  }
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }
  .status {
    padding: 2px 10px;
    &.green {
      background: rgba(40, 199, 111, 0.12);
      color: #41B883;
    }
    border-radius: 17px;
    &.red {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
    &.gray {
      background-color: rgba(128, 128, 128, 0.12);
      color: gray;
    }
  }
  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .check-icon {
    font-size: 22px;
  }
  .qr-td {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .qr-code-img {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
  .statistics {
    background-color: #ffffff;
    padding: 0 1.8rem;
    padding-bottom: 2rem;
    .card {
      background-color: #F8F8F8;
      height: 5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .data {
        font-weight: bold;
        color: #5E5873;
      }
    }
  }
  .name-table-col {
    min-width: 100px;
  }
  .type-table-col {
    min-width: 60px;
  }
  .status-table-col {
    min-width: 100px;
  }
</style>
